import React from "react";
import logo from "assests/logo.png";
import { Link } from "react-router-dom";
const FooterLogo = () => {
  return (
    <Link className="" to={"/"}>
      <img className="w-1/2 lg:w-2/3" src={logo} alt="" />
    </Link>
  );
};

export default FooterLogo;
